import template from './sw-cms-block-product-three-column.html.twig';
import './sw-cms-block-product-three-column.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
